import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { jobTypeShort } from '../constants/jobTypes';

function Candidates() {
  const [candidates, setCandidates] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCandidates();
  }, []);

  const fetchCandidates = async (searchOverride) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (searchOverride || search) params.set('search', searchOverride || search);
      const res = await api.get(`/candidates?${params.toString()}`);
      setCandidates(res.data.candidates || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchCandidates();
  };

  const handleShare = (candidate) => {
    const url = `${window.location.origin}/candidates/${candidate.id}`;
    navigator.clipboard.writeText(url);
    alert('链接已复制！');
  };

  return (
    <div className="container" style={{ paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header">
        <h1 className="page-title">人才广场</h1>
        <p className="page-subtitle">浏览 {total} 位涉外人才的公开资料</p>
      </div>

      <form onSubmit={handleSearch} style={{ display: 'flex', gap: 12, marginBottom: 32 }}>
        <input
          className="form-input"
          placeholder="搜索人才：姓名、职位、技能..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="submit" className="btn btn-primary">搜索</button>
      </form>

      {loading ? (
        <div className="loading">加载中...</div>
      ) : candidates.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">👥</div>
          <p className="empty-state-text">暂无公开的候选人资料</p>
          <Link to="/my-profile" className="btn btn-primary">创建我的资料</Link>
        </div>
      ) : (
        <div className="grid-2">
          {candidates.map(c => (
            <div key={c.id} className="card candidate-card">
              <Link to={`/candidates/${c.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="candidate-card-header">
                  <div className="candidate-avatar">{(c.name || '?')[0]}</div>
                  <div>
                    <div className="candidate-name">{c.name}</div>
                    <div className="candidate-title-text">{c.title || '涉外专业人才'}</div>
                  </div>
                </div>
                {c.summary && <div className="candidate-summary">{c.summary}</div>}
                <div className="job-card-meta" style={{ marginBottom: 8 }}>
                  {c.location && <span className="tag tag-gray">{c.location}</span>}
                  {c.experience && <span className="tag tag-green">{c.experience}</span>}
                  {c.jobTypes && <span className="tag">{
                    jobTypeShort(c.jobTypes) || c.jobTypes
                  }</span>}
                </div>
              </Link>
              {c.skills && (
                <div className="candidate-skills">
                  {c.skills.split(',').slice(0, 5).map((skill, i) => (
                    <span key={i} className="tag tag-purple">{skill.trim()}</span>
                  ))}
                </div>
              )}
              <div style={{ marginTop: 12 }}>
                <button className="btn btn-ghost btn-sm" onClick={() => handleShare(c)}>
                  分享资料
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Candidates;
